var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h16v16H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.511 2.655c.162.067.31.166.433.29l4.112 4.111a1.335 1.335 0 0 1 0 1.889l-4.112 4.111a1.335 1.335 0 0 1-1.888 0L2.944 8.945a1.335 1.335 0 0 1 0-1.889l4.112-4.111a1.335 1.335 0 0 1 1.455-.29M7.53 9.138a.667.667 0 0 0 1.138-.471V5.334a.667.667 0 0 0-1.333 0v3.333c0 .177.07.346.195.471m0 2a.667.667 0 1 0 .943-.943.667.667 0 0 0-.943.943",
  clipRule: "evenodd"
})));
export default SvgError;